import { BillingModel } from './../../models/medical-step-second.model';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NumberToTextService } from '../../services/utils/number-to-text.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-simb-2561',
  templateUrl: './simb-2561.component.html',
  styleUrls: ['./simb-2561.component.scss']
})
export class Simb2561Component implements OnInit {

  @Input('listOfData') listOfData: BillingModel[];
  @Input('isVisible') isVisible: Boolean;
  @Input('isSpinning') isSpinning: Boolean;
  @Input('haveBill') haveBill: Boolean;
  @Output() closeModal = new EventEmitter();
  @Output() setNewData = new EventEmitter();

  disabledMainCode: boolean = false;

  // dataFirstTable: MedicalStepSecondModel[] = [
  //   {
  //     code: '1',
  //     description: 'ค่ายาและสารอาหารทางเส้นเลือด (Drug & Perenteeral Nutrition)',
  //     total: 0
  //   },
  //   {
  //     code: '2',
  //     description: 'ค่าเวชภัณฑ์และอุปกรณ์ (Medical Supplies & Devices)',
  //     total: 0
  //   },
  //   {
  //     code: '3',
  //     description: 'ค่าบริการจัดหาโลหิตและส่วนประกอบของโลหิต (ฺBlood & Blood Components)',
  //     total: 0
  //   }
  // ];

  discount: number;
  total: number;
  amountCheck: Number;
  arrSplitData = new Array();
  displayData: BillingModel[] = [];
  discountData: BillingModel[] = [];
  haveBillData: BillingModel[] = [];

  constructor(private numberToTextService: NumberToTextService) {
  }

  ngOnInit() { }

  widthWindow(): number {
    if (window.innerWidth <= 800) {
      return 600;
    } else if (window.innerWidth <= 1024) {
      return 800;
    } else {
      return 1000;
    }
  }

  screenWidth() {
    var table = document.getElementById("basicTable");
    if (table != null) {
      let tableSize = {
        x: table.offsetWidth.toString() + 'px',
        y: table.offsetHeight.toString() + 'px'
      }
      return tableSize;
    } else {
      let tableSize = {
        x: '600px',
        y: '800px'
      }
      return tableSize;
    }
  }

  ngOnChanges(): void {
    console.log('ngOnChanges');
    // console.log('haveBill', this.haveBill);
    if (this.isVisible == true) {
      console.log("list data popup ", this.listOfData);
      this.listOfData.forEach(element => {
        let newExpense = element.expense
        if (typeof element.expense == 'string') {
          if (element.expense == "") {
            newExpense = "0.00"
          } else {
            newExpense = element.expense.replace(",", "");
          }
        }
        if (this.haveBill) {
          // console.log("change havebill :", this.haveBill + " afterDis: ", element.afterDiscount);
          this.haveBillData.push(element);
        } else {
          this.discount = (this.stringToNumber(newExpense) * this.stringToNumber(element.discount)) / 100;
          this.total = this.stringToNumber(newExpense) - this.discount;
          element.afterDiscount = this.total;
        }
      })
    }
  }

  close(passValue: boolean): void {

    this.listOfData.forEach(item => {
      if (item.expense == "") {
        item.expense = "0.00"
      }
    })
    if (passValue) {
      if (this.haveBillData.length > 0) {
        let listData = sessionStorage.getItem('tempSimp2561');
        this.listOfData = JSON.parse(listData);
        console.log("List data for SAVE ", this.listOfData);
        console.log("haveBillData    : ", this.haveBillData);
        this.listOfData.forEach(element => {
          // console.log("expense bill : ", element.expense);
          // console.log("afterDiscount bill : ", element.afterDiscount);

          for (let i = 0; i < this.haveBillData.length; i++) {
            if (element.healCode == this.haveBillData[i].healCode) {

              // console.log("check data ", element.expense != this.displayListOfData[i].expense);
              element.healCode = this.haveBillData[i].healCode;
              element.healGroup = this.haveBillData[i].healGroup;
              element.healDetail = this.haveBillData[i].healDetail;
              element.expense = this.haveBillData[i].expense;
              element.discount = this.haveBillData[i].discount;
              element.summary = this.haveBillData[i].summary;
              element.afterDiscount = this.haveBillData[i].afterDiscount;
              element.disabledMainCode = this.haveBillData[i].disabledMainCode;
            }
          }

          // for (let i = 0; i < this.discountData.length; i++) {
          //   if (element.healCode == this.discountData[i].healCode) {
          //     element.afterDiscount = this.discountData[i].afterDiscount;
          //   }
          // }
        });

        console.log("havebill DATA SAVE ", this.haveBillData);
        let data = {
          listData: this.listOfData,
          isSubmit: passValue,
          billType: 'n'
        }

        this.setNewData.emit(data);
      } else {

        let listData = sessionStorage.getItem('tempSimp2561');
        this.listOfData = JSON.parse(listData);
        console.log("List data for SAVE ", this.listOfData);
        console.log("Display for SAVE ", this.displayData);
        this.listOfData.forEach(element => {
          // console.log("expense list : ", element.expense);
          // console.log("afterDiscount list : ", element.afterDiscount);

          for (let i = 0; i < this.displayData.length; i++) {
            if (element.healCode == this.displayData[i].healCode) {

              // console.log("check data ", element.expense != this.displayListOfData[i].expense);
              element.healCode = this.displayData[i].healCode;
              element.healGroup = this.displayData[i].healGroup;
              element.healDetail = this.displayData[i].healDetail;
              element.expense = this.displayData[i].expense;
              element.discount = this.displayData[i].discount;
              element.summary = this.displayData[i].summary;
              element.afterDiscount = this.displayData[i].afterDiscount;
              element.disabledMainCode = this.displayData[i].disabledMainCode;
            }
          }

          // for (let i = 0; i < this.discountData.length; i++) {
          //   if (element.healCode == this.discountData[i].healCode) {
          //     element.afterDiscount = this.discountData[i].afterDiscount;
          //   }
          // }
        });
        console.log("LIST DATA SAVE ", this.listOfData);
        let data = {
          listData: this.listOfData,
          isSubmit: passValue,
          billType: 'n'
        }

        this.setNewData.emit(data);
      }
      this.displayData = [];
      this.haveBillData = [];
    } else {
      this.closeModalandNotSave()
      let data = {
        listData: this.listOfData,
        isSubmit: passValue,
        billType: 'n'
      }
      this.setNewData.emit(data);
    }
    this.closeModal.emit(false);
  }

  closeModalandNotSave(): void {
    let listData = sessionStorage.getItem('tempSimp2561');
    this.listOfData = JSON.parse(listData);
    this.listOfData.forEach(element => {
      let newExpense = element.expense
      if (typeof element.expense == 'string') {
        if (element.expense == "") {
          newExpense = "0.00"
        } else {
          newExpense = element.expense.replace(",", "");
        }
      }
      this.discount = (this.stringToNumber(newExpense) * this.stringToNumber(element.discount)) / 100;
      this.total = this.stringToNumber(newExpense) - this.discount;
      element.afterDiscount = this.total;
    })
  }

  resetValue(): void {
    this.haveBill = false;
    this.listOfData.forEach(element => {
      element.expense = ""
      element.afterDiscount = 0.00
    })
    this.displayData = [];
    this.haveBillData = [];
  }

  keyCurrency(event: any, index: number, discount: any): void {
    console.log("key Currency value  " + event.target.value);
    if (event.target.value == '') {
      // console.log('keyCurrency if');
      this.listOfData[index].expense = '';
      this.listOfData[index].afterDiscount = 0.00;
    } else {
      // this.discount = (parseFloat(event.target.value) * discount) / 100;
      // this.total = parseFloat(event.target.value) - this.discount;
      // this.listOfData[index].afterDiscount = this.total;
      // this.combineAfterDiscount(index);
      let newExpense = event.target.value.replace(",", "");
      let value = this.stringToNumber(newExpense);
      if (!isNaN(value)) {
        // console.log('not nan');
        if (this.haveBill) {
          //   this.listOfData[index].expense = this.listOfData[index].afterDiscount;
          this.listOfData[index].afterDiscount = this.stringToNumber(this.listOfData[index].afterDiscount);
        } else {
          let newExpense = event.target.value.replace(",", "");
          let value = this.stringToNumber(newExpense);
          this.discount = (value * this.stringToNumber(discount)) / 100;
          this.total = (value - this.discount);
          // console.log('discount = '+this.discount+' total = '+this.total);
          this.listOfData[index].afterDiscount = this.total;
        }
      } else {
        // console.log('nan');
        this.listOfData[index].expense = '';
        this.listOfData[index].afterDiscount = 0.00;
      }

      this.displayData.push(this.listOfData[index]);
      console.log("Display Currency", this.displayData);
    }
  }

  checkDiscount(event: any, index: number): void {
    // if (parseFloat(event.target.value) > this.stringToNumber(this.listOfData[index].expense)) {
    //   this.listOfData[index].afterDiscount = this.stringToNumber(this.listOfData[index].expense);
    // } else {
    //   this.listOfData[index].afterDiscount = parseFloat(event.target.value);
    // }
    // this.combineAfterDiscount(index);

    console.log('checkDiscount ', event.target.value);
    if (this.haveBill) {
      this.listOfData[index].afterDiscount = event.target.value;
      //this.listOfData[index].afterDiscount = event.target.value;
      //this.listOfData[index].afterDiscount = parseFloat(event.target.value);
      this.haveBillData.push(this.listOfData[index]);
      console.log("haveBill Discount", this.displayData);
      return;
    }
    if (event.target.value == '') {
      // console.log('checkDiscount if');
      this.listOfData[index].afterDiscount = 0.00
    } else {
      // console.log('checkDiscount else');
      if (this.stringToNumber(this.listOfData[index].discount) > 0) {
        if (this.stringToNumber(event.target.value) > (this.stringToNumber(this.listOfData[index].expense) - 0.01)) {
          this.listOfData[index].afterDiscount = this.stringToNumber(this.listOfData[index].expense) - 0.01;
        } else {
          this.listOfData[index].afterDiscount = event.target.value;
        }
      } else {
        if (this.stringToNumber(event.target.value) > this.stringToNumber(this.listOfData[index].expense)) {
          this.listOfData[index].afterDiscount = this.stringToNumber(this.listOfData[index].expense);
        } else {
          this.listOfData[index].afterDiscount = event.target.value;
        }
      }
      this.displayData.push(this.listOfData[index]);
      console.log("Display Discount", this.displayData);
    }
  }

  combineAfterDiscount(index: number): void {
    // console.log("after dis " + this.listOfData[index].discount);
    // var codeSplit = this.listOfData[index].code.substr(0, 1);
    // let sum = 0;
    // this.listOfData.forEach(element => {
    //   if (element.code.substr(0, 1) == codeSplit) {
    //     sum += element.afterDiscount
    //   }
    // });
    // this.dataFirstTable.forEach(element => {
    //   if (element.code == codeSplit) {
    //     element.total = sum;
    //   }
    // });
  }

  addComma(value: number): string {
    var parts = value.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  }

  stringToNumber(numberStr: string): number {
    // console.log('call string to number');
    return this.numberToTextService.checkNumber(numberStr);
  }


  //---------- Search Medical Billing-----------//

  search(event: any): void {
    console.log("input value ", event);
    //show table search
    if (event.trim().length > 0) {
      this.listOfData = this.listOfData.filter(element =>
        element.healDetail.indexOf(event) !== -1 ||
        element.healCode.indexOf(event) !== -1);
      // let filteredUsers: BillingModel[] = [];
      // for (var i = 0; i < this.listOfData.length; i++) {
      //   if (
      //     this.listOfData[i].healCode
      //       .toLowerCase()
      //       .search(this.dataSearch.toLowerCase()) != -1 ||
      //     this.listOfData[i].healDetail
      //       .toLowerCase()
      //       .search(this.dataSearch.toLowerCase()) != -1
      //   ) {
      //     filteredUsers.push(this.listOfData[i]);
      //   }
      // }
      // this.listOfData = filteredUsers.slice();

      this.listOfData.forEach(element => {
        if (element.healCode == '1.1' || element.healCode == '1.2' || element.healCode == '1.3' || element.healCode == '1.4' || element.healCode == '1.5'
          || element.healCode == '1.6' || element.healCode == '1.7' || element.healCode == '1.8' || element.healCode == '1.9' || element.healCode == '1.10'
          || element.healCode == '1.11' || element.healCode == '1.12' || element.healCode == '1.13' || element.healCode == '1.14' || element.healCode == '1.15'
          || element.healCode == '1.16' || element.healCode == '1.17' || element.healCode == '1.18' || element.healCode == '1.19' || element.healCode == '1.20'
          || element.healCode == '1.21' || element.healCode == '1.22' || element.healCode == '1.23' || element.healCode == '1.24' || element.healCode == '1.25'
          || element.healCode == '1.26' || element.healCode == '1.27' || element.healCode == '1.28' || element.healCode == '1.29' || element.healCode == '1.30'
          || element.healCode == '1.31' || element.healCode == '1.32'
          || element.healCode == '2.1' || element.healCode == '2.2' || element.healCode == '2.3' || element.healCode == '2.4' || element.healCode == '2.5'
          || element.healCode == '2.6' || element.healCode == '2.7' || element.healCode == '2.8' || element.healCode == '2.9'
        ) {
          this.disabledMainCode = true;
          element.disabledMainCode = this.disabledMainCode;
        }
      });

      console.log("list search data ", this.listOfData);

    } else {
      // list all data same first time to open pop up
      console.log(event.trim().length); //, "  list data ==>", listData);
      if (this.haveBill == false) {
        let listData = sessionStorage.getItem('tempSimp2561');
        this.listOfData = JSON.parse(listData);
        this.listOfData.forEach(element => {
          if (element.healCode == '1.1' || element.healCode == '1.2' || element.healCode == '1.3' || element.healCode == '1.4' || element.healCode == '1.5'
            || element.healCode == '1.6' || element.healCode == '1.7' || element.healCode == '1.8' || element.healCode == '1.9' || element.healCode == '1.10'
            || element.healCode == '1.11' || element.healCode == '1.12' || element.healCode == '1.13' || element.healCode == '1.14' || element.healCode == '1.15'
            || element.healCode == '1.16' || element.healCode == '1.17' || element.healCode == '1.18' || element.healCode == '1.19' || element.healCode == '1.20'
            || element.healCode == '1.21' || element.healCode == '1.22' || element.healCode == '1.23' || element.healCode == '1.24' || element.healCode == '1.25'
            || element.healCode == '1.26' || element.healCode == '1.27' || element.healCode == '1.28' || element.healCode == '1.29' || element.healCode == '1.30'
            || element.healCode == '1.31' || element.healCode == '1.32'
            || element.healCode == '2.1' || element.healCode == '2.2' || element.healCode == '2.3' || element.healCode == '2.4' || element.healCode == '2.5'
            || element.healCode == '2.6' || element.healCode == '2.7' || element.healCode == '2.8' || element.healCode == '2.9'
          ) {
            this.disabledMainCode = true;
            element.disabledMainCode = this.disabledMainCode;
          }
          this.displayData.forEach(display => {
            // element.healCode;
            // element.expense;
            console.log("temp list", display.healCode, " exp ", display.expense);

            console.log("check ", display.healCode == element.healCode);
            if (display.healCode == element.healCode) {
              element.expense = display.expense;
              element.afterDiscount = display.afterDiscount;
            }

          });
        });
      } else {
        let listData = sessionStorage.getItem('tempSimp2561');
        this.listOfData = JSON.parse(listData);
        this.listOfData.forEach(element => {
          if (element.healCode == '1.1' || element.healCode == '1.2' || element.healCode == '1.3' || element.healCode == '1.4' || element.healCode == '1.5'
            || element.healCode == '1.6' || element.healCode == '1.7' || element.healCode == '1.8' || element.healCode == '1.9' || element.healCode == '1.10'
            || element.healCode == '1.11' || element.healCode == '1.12' || element.healCode == '1.13' || element.healCode == '1.14' || element.healCode == '1.15'
            || element.healCode == '1.16' || element.healCode == '1.17' || element.healCode == '1.18' || element.healCode == '1.19' || element.healCode == '1.20'
            || element.healCode == '1.21' || element.healCode == '1.22' || element.healCode == '1.23' || element.healCode == '1.24' || element.healCode == '1.25'
            || element.healCode == '1.26' || element.healCode == '1.27' || element.healCode == '1.28' || element.healCode == '1.29' || element.healCode == '1.30'
            || element.healCode == '1.31' || element.healCode == '1.32'
            || element.healCode == '2.1' || element.healCode == '2.2' || element.healCode == '2.3' || element.healCode == '2.4' || element.healCode == '2.5'
            || element.healCode == '2.6' || element.healCode == '2.7' || element.healCode == '2.8' || element.healCode == '2.9'
          ) {
            this.disabledMainCode = true;
            element.disabledMainCode = this.disabledMainCode;
          }
          this.haveBillData.forEach(bill => {
            // element.healCode;
            // element.expense;
            console.log("bill list", bill.healCode, " expense: ", bill.expense + " afterDis: ", bill.afterDiscount);
            console.log("list exp ", element.expense + " afterDis: ", element.afterDiscount);
            console.log("check ", bill.healCode == element.healCode);
            if (bill.healCode == element.healCode) {
              element.expense = bill.expense;
              element.afterDiscount = bill.afterDiscount;
            }

          });

        });

      }

    }
  }
}
